import React from 'react'
import ReactECharts from 'echarts-for-react'

export default function SingleGauge({ schema, ...props }) {
  const optionProject = {
    color: schema.color,
    title: {
      text: schema.name,
      left: 'center',
      bottom: 5,
      textStyle: {
        color: '#575757',
        overflow: 'truncate',
        fontSize: '16',
        ellipsis: '...',
        lineOverflow: 'truncate',
      },
    },
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        pointer: {
          show: false,
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
        },
        axisLine: {
          lineStyle: {
            width: 20,
          },
        },
        splitLine: {
          show: false,
          distance: 0,
          length: 10,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
          distance: 50,
        },
        data: [
          {
            value: schema.value,
            name: schema.label,
            title: {
              offsetCenter: ['0%', '15%'],
            },
            detail: {
              valueAnimation: true,
              offsetCenter: ['0%', '-15%'],
            },
          },
        ],
        title: {
          fontSize: 14,
        },
        detail: {
          fontSize: 14,
          formatter: '{value}%',
        },
      },
    ],
  }

  return (
    <div>
      <ReactECharts
        option={optionProject}
        style={{ height: '200px', width: '100%' }}
        className={'react_for_echarts'}
      />
    </div>
  )
}
